import { get, putJson, postJson, del } from '../httpClient';

/**
 * Client for /api/org/:orgId/configurations + /api/org/:orgId/sender-domain.
 *
 * Owner-only — the server rejects non-owners with 403
 * (requirePermission('MANAGE_SUBSCRIPTION')). Returned `config` always
 * contains every supported key with a default value filled in.
 */
export const orgConfigurationsAPI = {
  /** GET /api/org/:orgId/configurations */
  getConfig: orgId => get(`/api/org/${orgId}/configurations`),

  /** PUT /api/org/:orgId/configurations — body: { config: { … } } */
  updateConfig: (orgId, config) =>
    putJson(`/api/org/${orgId}/configurations`, { config }),

  // ── Sender domain ──
  getSenderDomain: orgId => get(`/api/org/${orgId}/sender-domain`),
  connectSenderDomain: (orgId, domain) => postJson(`/api/org/${orgId}/sender-domain`, { domain }),
  verifySenderDomain: orgId => postJson(`/api/org/${orgId}/sender-domain/verify`, {}),
  setSenderFromEmail: (orgId, fromEmail) => putJson(`/api/org/${orgId}/sender-domain/from`, { fromEmail }),
  disconnectSenderDomain: orgId => del(`/api/org/${orgId}/sender-domain`),
};
